import React, { useState, useRef } from 'react';
import Slider from "react-slick";
import './CSS/Employees.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

function Employees() {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const sliderRef = useRef(null);

  const employeeList = [
    {
      name: 'Alvaro Gallego Cabezas',
      position: 'Veterinario Generalista',
      image: '/assets/images/alvaro_vet.JPG',
      skills: ['Medicina Interna Felina', 'Medicina Interna Canina', 'Cirugía y Electrocirugía', 'Urgencias']
    },
    {
      name: 'Alberto Fernández Lommen',
      position: 'Veterinario Generalista',
      image: '/assets/images/alberto_vet.JPG',
      skills: ['33 años de experiencia', 'Medicina Interna Canina', 'Medicina Interna Felina', 'Oncología', 'Urgencias']
    },
    {
      name: 'Carlota Wensell Gallego',
      position: 'Auxiliar Técnico Veterinaria',
      image: '/assets/images/carlota_aux.JPG',
      skills: ['Asistencia Quirúrgica y Clínica', 'Manejo catfriendly', 'Laboratorio', 'Organización']
    },
    {
      name: 'Ana Sanchez Rodríguez',
      position: 'Auxiliar Técnico Veterinaria',
      image: '/assets/images/ana_aux.JPG',
      skills: ['Asistencia Quirúrgica y Clínica', 'Manejo catfriendly', 'Laboratorio', 'Organización']
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleCardClick = (employee) => {
    setSelectedEmployee(employee);
    setShowPopup(true);
    if (sliderRef.current) {
      sliderRef.current.slickPause();
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    if (sliderRef.current) {
      sliderRef.current.slickPlay();
    }
  };

  return (
    <section id="employees" className="employees-section">
      <h1>Nuestro Equipo</h1>
      <div className="employees-carousel">
        <Slider {...settings} ref={sliderRef}>
          {employeeList.map((employee, index) => (
            <div key={index} className="employee-card" onClick={() => handleCardClick(employee)}>
              <div className="employee-image" style={{ backgroundImage: `url(${employee.image})` }}></div>
              <div className="employee-details">
                <h2>{employee.name}</h2>
                <p>{employee.position}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <span className="close-popup" onClick={closePopup}>&times;</span>
            <div className="popup-image" style={{ backgroundImage: `url(${selectedEmployee.image})` }}></div>
            <h2>{selectedEmployee.name}</h2>
            <p>{selectedEmployee.position}</p>
            <h3>Aptitudes</h3>
            <ul>
              {selectedEmployee.skills.map((skill, index) => (
                <li key={index}>✓ {skill}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
}

export default Employees;